/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const avatarTokens = {
  BackgroundBaseColor: '#ebecec',
  BackgroundInitialsDefaultColor: '#f0eae1',
  BackgroundInitialsPrimaryColor: '#7968b9',
  BackgroundInitialsSecondaryColor: '#4176bc',
  BackgroundInitialsTertiaryColor: '#2d9e90',
  FontWeight: '500',
  FontColorDefault: '#656b6b',
  FontColorInitialsDefaultColor: '#656b6b',
  FontColorInitialsPrimaryColor: '#ffffff',
  FontColorInitialsSecondaryColor: '#ffffff',
  FontColorInitialsTertiaryColor: '#ffffff',
  FontColorWhite: '#ffffff',
  BorderStyleBaseDefault: 'solid',
  BorderWidthBaseDefault: '1px',
  BorderColorBaseDefault: '#dedfdf',
  BorderRadius: '50%',
  SizeDefault: '38px',
  SizeMessages: '32px',
} as const;
